import { render } from "./Interface.vue?vue&type=template&id=4cb6aa98"
import script from "./Interface.vue?vue&type=script&lang=js"
export * from "./Interface.vue?vue&type=script&lang=js"

import "./Interface.vue?vue&type=style&index=0&id=4cb6aa98&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__